import React from 'react'

import Button from '@components/shared/Button'
import LinkButton from '@components/shared/LinkButton'
import NFIcon from '@components/shared/NFIcon'

interface Action {
  type: 'button' | 'link'
  text?: string
}

interface LinkAction extends Action {
  type: 'link'
  href: string
  external?: boolean
}

interface ButtonAction extends Action {
  type: 'button'
  onClick: () => void
  disabled?: boolean
}

interface Props {
  title: React.ReactNode
  subtitle?: React.ReactNode
  icon?: string
  imageContent?: React.ReactNode
  action?: LinkAction | ButtonAction
}

const NonIdealState: React.FC<Props> = ({ title, subtitle, icon, imageContent, action }: Props) => {
  return (
    <div className="inset-0 flex flex-col flex-1 bg-gray-light dark:bg-black-bg items-center px-2 mt-20">
      {icon && (
        <NFIcon
          icon={icon}
          className="text-[45px] nf-icon text-gray-icons dark:text-gray-icons-dm mb-2"
        />
      )}
      {imageContent}
      <h1 className="w-full text-center text-h3 mb-2">{title}</h1>
      {subtitle && <p className="text-md text-gray-text mb-8 text-center">{subtitle}</p>}
      {action?.type === 'link' && (
        <LinkButton
          href={action.href}
          variant="primary"
          size="lg"
          className="mt-4"
          external={action.external}>
          {action.text}
        </LinkButton>
      )}
      {action?.type === 'button' && (
        <Button
          variant="primary"
          size="lg"
          onClick={action.onClick}
          className="mt-4"
          disabled={action.disabled}>
          {action.text}
        </Button>
      )}
    </div>
  )
}

export default NonIdealState
